import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import TelegramIcon from '@material-ui/icons/Telegram';
import TwitterIcon from '@material-ui/icons/Twitter';
// import MediumIcon from '@material-ui/icons/MediumOutlined';
import Pancake from '../../img/pancakeswap.png'
import Coingeck from '../../img/coingecko.png'
import Medium from '../../img/medium(2).png'


import './footer.css'
// images
import logoimg from '../../img/logofinal.png'

const Footer = (props) => {
  return (
    <div className="pcc---headerMenu pcc---gray_background pcc---footer mt-5 d-block" style={{backgroundColor:'#fdd53b',color:'black'}}>
        <Container maxWidth="lg">
        <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            xs={11}
            className="bg-dark mx-auto px-md-5"
            >
                <Grid
                    container
                    direction="column"
                    justify="flex-start"
                    xs={12}
                    sm={6}
                    className="mt-4 pt-md-5 pb-md-5 pt-3 px-4 mt-3"
                    >
                       <h3 className="text-left" style={{color:"#222529"}} >It's all about the voice of the people <br />- The community.</h3> 
                </Grid>
                <Grid
                    container
                    direction="column"
                    justify="flex-start"
                    xs={12}
                    sm={6}
                    className="mt-4 pt-md-5 pb-md-5 pb-5 px-4"
                    >
                        <form className="Footer---form" style={{color:"#ffffff"}}>
                            <div>
                                <input type="email" className="email" placeholder="Enter your email address" />
                                <input type="submit" className="submit" />
                                {/* <p className="mt-2 text-left" style={{color:'black'}}>SUBSCRIBE TO OUR NEWSLETTER</p> */}
                            </div> 
                        </form> 
                </Grid>
            </Grid>
        </Container>
        <br />
        <div style={{color:"#ffffff",backgroundColor: '#feb13e'}} >
          <Container 
              maxWidth="xl"
              className="mt-3 py-2"
          >
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid  
                  xs={2} 
                  md={1}
                  lg={2}
                  className="text-left"
                >
                  <a href="#">
                      <img src={logoimg} style={{width: 100, height: 'auto'}} />
                  </a>
                </Grid>
                <Grid 
                  container 
                  direction="row"
                  justify="center"
                  xs={8}
                  lg={7}
                  className="d-none d-lg-flex"
                >
                  <ul style={{marginBottom: 0}}>
                    <li>
                      <a href='/#Feature' style={{color:'black'}}>Features</a>
                    </li>
                    <li>
                      <a href='/#Team' style={{color:'black'}}>Team</a>
                    </li>
                    <li>
                      <a href='/white-paper' style={{color:'black'}}>Litepaper</a>
                    </li>
                    <li>
                      <a href='/#FAQ' style={{color:'black'}}>F.A.Q</a>
                    </li>
                    <li>
                      <a href='/#roadmap' style={{color:'black'}}>Roadmap</a>
                    </li>
                    <li>
                      <a href='/lock-lp-token' style={{color:'black'}}>Locker</a>
                    </li>
                   
                  </ul>
                </Grid>
                <Grid 
                container 
                xs={10} 
                md={3}
                lg={3}
                justify="flex-end"
                className="text-right"
                >
                  <a 
                    href='https://t.me/pcat_tokens' 
                    target="_blank" 
                    className="pcc---footer-menu-icons"
                  >
                      <TelegramIcon style={{color:'#fdd53b'}} />
                  </a>
                  <a 
                    href='https://twitter.com/pussycatcore' 
                    target="_blank" 
                    className="pcc---footer-menu-icons"
                  >
                    <TwitterIcon style={{color:'#fdd53b'}} />
                  </a>
                  <a 
                    href='https://exchange.pancakeswap.finance/#/swap?outputCurrency=0x41d7ca990138dddd70aef6a66cce6cf37b478428' 
                    target="_blank" 
                    className="pcc---footer-menu-icons"
                  >
                    <svg id="Group_676" data-name="Group 676" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.282 23.536">
                      <path id="Path_219" data-name="Path 219" d="M-87.983-126.405a5.662,5.662,0,0,1,2.644-5.359,19.469,19.469,0,0,1,2.485-1.4.571.571,0,0,0,.376-.729q-.52-2.576-1-5.161a2.879,2.879,0,0,1-.011-1.056,2.253,2.253,0,0,1,2.488-1.8,2.269,2.269,0,0,1,2.06,2.241c.026,1.538.008,3.077.011,4.616,0,.687.043.683.739.663q1.705-.049,3.413,0c.674.019.718.02.719-.641,0-1.5-.006-2.992,0-4.488a2.3,2.3,0,0,1,2.129-2.4,2.34,2.34,0,0,1,2.52,2.1,3.48,3.48,0,0,1-.066,1.016c-.282,1.628-.57,3.256-.883,4.878-.08.414.038.589.416.774a18.2,18.2,0,0,1,2.454,1.373,5.86,5.86,0,0,1,2.752,4.417v1.1c-.089.136-.183.268-.266.407a17.024,17.024,0,0,1-1.16,1.923,8.337,8.337,0,0,1-3.147,2.3,17.274,17.274,0,0,1-10.07,1.235,13.519,13.519,0,0,1-5.524-2.053,6.585,6.585,0,0,1-2.936-3.7A1.177,1.177,0,0,0-87.983-126.405Zm5.67-1.487.114.044a2.193,2.193,0,0,0,.475,1.51.973.973,0,0,0,1.606-.023,2.61,2.61,0,0,0,.007-2.955.964.964,0,0,0-1.648.034A7.748,7.748,0,0,0-82.313-127.892Zm11.528-.02a2.127,2.127,0,0,0-.464-1.426.979.979,0,0,0-1.582-.029,2.584,2.584,0,0,0,0,3.053.964.964,0,0,0,1.55-.006A2.267,2.267,0,0,0-70.785-127.912Z" transform="translate(88.01 141.924)" fill="#fed414"/>
                      <path id="Path_220" data-name="Path 220" d="M-87.966,39.534a1.177,1.177,0,0,1,.148.256,6.585,6.585,0,0,0,2.936,3.7,13.519,13.519,0,0,0,5.524,2.053,17.274,17.274,0,0,0,10.07-1.235,8.337,8.337,0,0,0,3.147-2.3,17.023,17.023,0,0,0,1.16-1.923c.083-.139.177-.272.266-.408q0,.353,0,.707a6.18,6.18,0,0,1-3.2,4.922,14.2,14.2,0,0,1-6.347,2.124,16.888,16.888,0,0,1-9.453-1.5,10.551,10.551,0,0,1-1.358-.807A5.882,5.882,0,0,1-87.966,39.534Z" transform="translate(87.993 -24.016)" fill="#feb134"/>
                      <path id="Path_221" data-name="Path 221" d="M184.2,30.165q0-.354,0-.707,0-.548,0-1.1Z" transform="translate(-160.917 -13.798)" fill="#7d7d7d"/>
                    </svg>
                  </a>
                  <a 
                    href='https://www.coingecko.com/en/coins/pcatv3' 
                    target="_blank" 
                    className="pcc---footer-menu-icons"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.312 43.147">
                      <g id="Group_833" data-name="Group 833" transform="translate(-1541.131 -8308.876)">
                        <path id="Path_882" data-name="Path 882" d="M-153.543-111.834c-.867-2.891-1.671-5.866-2.657-8.777a27.455,27.455,0,0,0-4.443-7.89c-1.947-2.526-4.758-3.7-7.637-4.684-2.013-.689-4.1-1.177-6.146-1.758-.233-.066-.459-.154-.916-.309a11.9,11.9,0,0,1,6.191.295c2.569.646,4.549,2.285,6.552,3.9,3.1,2.511,5.922,5.223,7.6,8.963a20.277,20.277,0,0,1,1.565,9.924.868.868,0,0,1-.083.3C-153.544-111.8-153.619-111.773-153.543-111.834Z" transform="translate(1730.811 8444.424)" fill="#feb134"/>
                        <g id="Group_674" data-name="Group 674" transform="translate(1541.131 8318.287)">
                          <g id="Group_673" data-name="Group 673" transform="translate(0 0)">
                            <path id="Path_884" data-name="Path 884" d="M-258.322-91.941l4.638,1.619c1.361.513,6.446,2.389,7.486,3.038a3.276,3.276,0,0,1,1.021,5.012,19.22,19.22,0,0,1-2.512,2.891c-2.72,2.635-5.305,5.363-6.881,8.878-.039.087-4.193,11.778-4.193,11.778a19.149,19.149,0,0,1-2.308-.117,25.576,25.576,0,0,1-3.086-.516,24.362,24.362,0,0,1-5.615-2.24,21.727,21.727,0,0,1-5.327-4.183s3.884-14.389,4.152-17.636c.164-1.991.5-3.974,1.959-5.425a10.754,10.754,0,0,1,8.85-3.309C-259.53-92.1-258.927-92.012-258.322-91.941Zm-2.787,1.7a3.408,3.408,0,0,0-3.395,3.39,3.456,3.456,0,0,0,3.45,3.439,3.421,3.421,0,0,0,3.376-3.494A3.371,3.371,0,0,0-261.109-90.24ZM-248.2-80.128c-1.765.388-3.372.781-5,1.087a9.128,9.128,0,0,1-5.089-.615C-255.862-77.423-251.386-78.391-248.2-80.128Zm.176-3.18-.018-.343c-.3-.173-.634-.52-.889-.469a1.043,1.043,0,0,0-.628.764c-.02.19.447.6.693.6C-248.58-82.758-248.3-83.109-248.021-83.308Z" transform="translate(275.098 92.459)" fill="#fed414"/>
                            <path id="Path_887" data-name="Path 887" d="M-210.55-79.954a3.812,3.812,0,0,1,3.88,3.772,3.868,3.868,0,0,1-3.818,3.951,3.908,3.908,0,0,1-3.9-3.889A3.854,3.854,0,0,1-210.55-79.954Zm.026,6.563a2.679,2.679,0,0,0,2.721-2.653,2.736,2.736,0,0,0-2.752-2.739,2.7,2.7,0,0,0-2.655,2.726A2.637,2.637,0,0,0-210.524-73.392Z" transform="translate(224.614 82.134)" fill="#feb134"/>
                            <path id="Path_888" data-name="Path 888" d="M-175.768-91.861a4.655,4.655,0,0,1,3.254.1,2.174,2.174,0,0,1,1.383,1.518Z" transform="translate(192.818 92.105)" fill="#feb134"/>
                            <path id="Path_890" data-name="Path 890" d="M-205.5-68.724a2.332,2.332,0,0,1-2.376-2.358,2.385,2.385,0,0,1,2.348-2.41,2.42,2.42,0,0,1,2.433,2.422A2.369,2.369,0,0,1-205.5-68.724Z" transform="translate(219.511 76.747)" fill="none"/>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </a>
                </Grid>
            </Grid>
          </Container>
        </div>
    </div>
  );
}

export default Footer;
